import { render, staticRenderFns } from "./Edit_tech.vue?vue&type=template&id=c115171a&scoped=true&"
import script from "./Edit_tech.vue?vue&type=script&lang=js&"
export * from "./Edit_tech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c115171a",
  null
  
)

export default component.exports